var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar d-flex align-center"},[_c('div',{staticClass:"progress-bar__value"},[_c('div',{staticClass:"progress-bar__current-value",style:({ width: _vm.getPercentByStep, backgroundColor: '#7811C9' })})])])}
var staticRenderFns = []

export { render, staticRenderFns }